import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Grid,
  Chip,
  Divider,
  Paper,
  Container,
  Button,
  Pagination,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useNavigate } from "react-router-dom";
import { Homeimages } from "../../../../assets";
import { projectsData, ProjectData } from "./AllProjectData";

const PAGE_SIZE = 5;

const KokapetLuxury: React.FC = () => {
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const sectionRef = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   sectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  // }, [page]);

  const totalProjects = projectsData.length;
  const totalPages = Math.ceil(totalProjects / PAGE_SIZE);
  const startIndex = (page - 1) * PAGE_SIZE;
  const endIndex = startIndex + PAGE_SIZE;
  const projects = projectsData.slice(startIndex, endIndex);

  const handleWhatsApp = (title: string) => {
    const phoneNumber = "+919885420885";
    const message = `Hi, I'm interested in ${title}. Please share details.`;
    window.open(
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

const handlePageChange = (_: React.ChangeEvent<unknown>, value: number) => {
  setPage(value);

  // 🔥 SCROLL TO TOP OF NEWCARD ONLY
  setTimeout(() => {
    sectionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, 50);
};
  return (
    <Box
      ref={sectionRef}
      sx={{ background: "#f5f6f8", p: { xs: 2, md: 4 }, scrollMarginTop: "100px",}}
    >
      <Container maxWidth="xl">
        {projects.map((project, index) => {
          const isReverse = project.isReverse || index % 2 !== 0;
          const bhkText = project.bhk || "N/A";
          const sqftText = project.sqft || "N/A";

          const specs = [
            { label: "SFT", value: sqftText },
            { label: "CONFIGURATION", value: bhkText },
            { label: "RERA NO", value: project.rera || "N/A" },
          ];

          return (
            <Box key={project.title} sx={{ mb: 8 }}>
              <Grid
                container
                spacing={6}
                alignItems="center"
                
                sx={{
                  flexDirection: {
                    xs: "column",
                    md: isReverse ? "row-reverse" : "row",
                  },
                }}
              >
                <Grid item xs={12} md={6} sx={{ order: { xs: 2, md: 1 } }}>
                  <Typography variant="h4" fontWeight={600} gutterBottom>
                    {project.title}
                  </Typography>

                  <Typography variant="body2" color="text.secondary" mb={2}>
                    {project.location}
                  </Typography>

                  <Divider sx={{ mb: 2 }} />

                  <Grid container spacing={2}>
                    {specs.map((item, i) => (
                      <Grid item xs={12} md={4} key={i}>
                        <Paper
                          sx={{
                            p: 2,
                            borderRadius: 2,
                            background: "#f9fafc",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                            textAlign: "center",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#7a8ca5",
                              letterSpacing: 1,
                              fontWeight: 600,
                            }}
                          >
                            {item.label}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ mt: 1, color: "#000" }}
                          >
                            {item.value}
                          </Typography>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>

                  <Typography
                    variant="caption"
                    sx={{
                      letterSpacing: 1,
                      mt: 4,
                      mb: 2,
                      display: "block",
                      fontWeight: 700,
                    }}
                  >
                    KEY HIGHLIGHTS
                  </Typography>
                  <Box
                    mt={2}
                    display="flex"
                    justifyContent="center"
                    flexWrap="wrap"
                    gap={1}
                  >
                    {(project.highlights?.length
                      ? project.highlights
                      : ["No highlights available"]
                    ).map((h, i) => (
                      <Chip
                        key={i}
                        label={h}
                        sx={{
                          background: "#eef2f7",
                          boxShadow:
                            "rgba(0, 0, 0, 0.1) 0px 8px 32px 0px",
                          fontSize: 12,
                          borderRadius: "20px",
                        }}
                      />
                    ))}
                  </Box>

                  <Box mt={3} display="flex" justifyContent="center" gap={2}>
                    <Button
                      variant="contained"
                      endIcon={<ArrowForwardIcon />}
                      onClick={() => project.link && navigate(project.link)}
                      sx={{
                        background: "#0f63a5",
                        textTransform: "none",
                        borderRadius: "30px",
                        px: 3,
                        py: 1,
                        fontWeight: 500,
                        boxShadow: "0 4px 14px rgba(15,99,165,0.4)",
                        "&:hover": { background: "#0c4f85" },
                      }}
                    >
                      Explore More
                    </Button>

                    <Button
                      variant="outlined"
                      startIcon={<WhatsAppIcon />}
                      onClick={() => handleWhatsApp(project.title)}
                      sx={{
                        borderColor: "#25D366",
                        color: "#25D366",
                        textTransform: "none",
                        borderRadius: "30px",
                        px: 3,
                        py: 1,
                        fontWeight: 500,
                        "&:hover": {
                          borderColor: "#1ebe5d",
                          background: "rgba(37,211,102,0.08)",
                        },
                      }}
                    >
                      WhatsApp
                    </Button>
                  </Box>
                </Grid>

                <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: 2 } }}>
  <Box
    sx={{
      position: "relative",
      borderRadius: 3,
      overflow: "hidden",
      cursor: "pointer",
    }}
  >
    <Box
      component="img"
      src={project.image}
      alt={project.title}
      sx={{
        width: "100%",
        height: {
          xs: "320px",
          md: "500px",
        },
        objectFit: "cover",
        borderRadius: "16px",
      }}
    />
  </Box>
</Grid>
              </Grid>

              <Box sx={{ display: "flex", alignItems: "center", mt: 6 }}>
                <Box 
                onClick={() => project.link && navigate(project.link)}
                sx={{ flex: 1, height: "2px", background: "#0f63a5" }} />
                <Box
                  sx={{
                    mx: 2,
                    width: 90,
                    height: 60,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                  }}
                >
                  <Box
                    component="img"
                    src={Homeimages.rwbluelogo2}
                    alt="divider"
                    sx={{ width: "100%", height: "100%", objectFit: "contain" }}
                  />
                </Box>
                <Box sx={{ flex: 1, height: "2px", background: "#0f63a5" }} />
              </Box>
            </Box>
          );
        })}

        {totalPages > 1 && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              color="primary"
              size="large"
            />
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default KokapetLuxury;